'use client';

import Script from 'next/script';
import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { checkIsWeischerAdTestDomain } from '@cineamo/ui/src/helpers/environment-helper';

type AditionScriptsProps = {
    domainConfiguration?: DomainConfigurationDto;
};

/**
 * Ad test for Weischer Online Marketing.
 * CURRENTLY ONLY VISIBLE FOR: ad-test.cineamo.dev
 *
 * @constructor
 */
const AditionScripts: React.FC<AditionScriptsProps> = ({ domainConfiguration }) => {
    if (!domainConfiguration) return null;
    if (!checkIsWeischerAdTestDomain(domainConfiguration.domain)) return null;

    return (
        <>
            <Script
                src="https://imagesrv.adition.com/js/adition.js"
                strategy="afterInteractive"
            />
            <Script
                src="https://ad1.adfarm1.adition.com/js?wp_id=5244482"
                strategy="afterInteractive"
            />
        </>
    );
};

export default AditionScripts;
